module.exports = __webpack_public_path__ + "img/eventworks-logo.0b3a2e1a.jpg";